import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import SiteRenderer from "@/components/SiteRenderer";

export default function Preview() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    api
      .get(`/public/projects/${id}`)
      .then((r) => setData(r.data))
      .catch(() => setErr("Site not found"));
    const p = new URLSearchParams(window.location.search).get("purchase");
    if (p === "success") { toast.success("Payment successful — thank you for your order!"); window.history.replaceState({}, "", `/preview/${id}`); }
    else if (p === "cancel") { toast("Checkout canceled."); window.history.replaceState({}, "", `/preview/${id}`); }
  }, [id]);

  if (err)
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-3 bg-[#f2f0eb]">
        <div className="label-tech">{err}</div>
        <Link to="/" className="text-[#ff3b00] font-tech text-sm">← Back home</Link>
      </div>
    );
  if (!data) return <div className="min-h-screen flex items-center justify-center bg-[#f2f0eb] label-tech animate-pulse">Loading site…</div>;

  return (
    <div data-testid="public-preview">
      <SiteRenderer schema={data.schema_data} projectId={id} />
    </div>
  );
}
